/* istanbul ignore file */
import { Amplify } from "aws-amplify";
import { getDefaultCognitoAuthConfigurationFromEnvVariables } from "@covertree/auth";
import { fetchAuthSession } from "aws-amplify/auth";

export const configureAmplify = () => {
  Amplify.configure(
    {
      Auth: {
        Cognito: getDefaultCognitoAuthConfigurationFromEnvVariables(),
      },
      API: {
        GraphQL: {
          defaultAuthMode: "userPool",
          endpoint: process.env.VITE_AWS_GRAPHQL_API!,
          region: "us-east-1",
        },
      },
    },
    {
      API: {
        GraphQL: {
          headers: async () => ({
            Authorization: (
              await fetchAuthSession()
            ).tokens?.idToken?.toString() as string,
          }),
        },
      },
    }
  );
};
